import {
  getChartFields,
  WEIGHTED_BY_COUNT,
} from "web/components/Charts/chart-util"
import TileChartSettingsModal from "../Modal/TileChartSettingsModal"

export default function TileChartSettingsModalWrapper({
  backButtonHandler,
  close,
  overview,
  tile,
  tileEntry,
}) {
  const tileDimension = { height: tileEntry.height, width: tileEntry.width }

  const allFields = [...tile.available_fields, WEIGHTED_BY_COUNT]

  const [kindFieldData, groupFieldData, weightFieldData] =
    getChartFields(allFields)

  const findMatchingOption = (options, id) => {
    return !!id && options.find((options) => options.value === id)
  }

  const intialGroupByValue =
    findMatchingOption(groupFieldData.lookup_values, tile.group_field_id) ||
    groupFieldData.lookup_values[0]

  const intialWeightByValue =
    findMatchingOption(weightFieldData.lookup_values, tile.weight_field_id) ||
    WEIGHTED_BY_COUNT

  const intialKindValue =
    findMatchingOption(kindFieldData.lookup_values, tile.kind) ||
    kindFieldData.lookup_values[0]

  const intialChartTileSetting = {
    groupBy: intialGroupByValue,
    height: tileDimension.height,
    kind: intialKindValue,
    weightBy: intialWeightByValue,
    width: tileDimension.width,
  }

  async function saveChartTileSettingsHandler(settings) {
    const canSaveChartTileTitle = !!settings.title?.value?.trim().length

    const canSaveChartTileDimensions =
      tile.height !== settings.height || tile.width !== settings.width

    const changedChartTileDimensions = {
      [overview.type]: {
        tile_entries_attributes: [
          {
            id: tileEntry?.id,
            height: settings.height,
            width: settings.width,
          },
        ],
      },
    }

    const changedChartCoordinates = {
      group_field_id: settings.groupBy.value,
      weight_field_id:
        settings.weightBy.value === WEIGHTED_BY_COUNT.id
          ? null
          : settings.weightBy.value,
    }

    const changedChartTileSettings = {
      overview_tile: {
        ...(canSaveChartTileTitle && { name: settings.title.value.trim() }),
        ...changedChartCoordinates,
        kind: settings.kind.value,
      },
    }

    if (canSaveChartTileDimensions) {
      await overview.update(changedChartTileDimensions)
    }
    await tile.update(changedChartTileSettings)
    close()
  }

  return (
    <TileChartSettingsModal
      backButtonHandler={backButtonHandler}
      close={close}
      groupFieldData={groupFieldData}
      intialChartTileSetting={intialChartTileSetting}
      kindFieldData={kindFieldData}
      saveChartTileSettingsHandler={saveChartTileSettingsHandler}
      tile={tile}
      tileEntry={tileEntry}
      weightFieldData={weightFieldData}
      overviewType={overview.type}
    />
  )
}
